/**
 * @description フォーム設定
 */
export function setForm(): void {
  // 入力画面に戻るボタン
  $('#btn_back').on('click', function () {
    $('input[name="page_name"]').val('input');
    $('#frm').trigger('submit');
    return false;
  });
  // 送信するボタン
  $('#btn_send').on('click', function () {
    $('input[name="page_name"]').val('finish');
    grecaptcha.ready(function () {
      grecaptcha.execute(recaptcha_site_key, { action: recaptcha_action }).then(function (token: any) {
        $('#recaptcha_token').val(token);
        $('#frm').trigger('submit');
      });
    });
    return false;
  });
}
